import { gql } from '@apollo/client';
import { DocumentFragment } from 'approot/shared/graphql/document/document.graphql';

export const assessmentRubricsFragment = gql`
  fragment AssessmentRubricsFragment on Assessment {
    id
    unitRubric {
      id
      documentType
      document {
        ...documentFragment
      }
    }
    aeRubric {
      id
      documentType
      document {
        ...documentFragment
      }
    }
    victorianRubric {
      id
      documentType
      document {
        ...documentFragment
      }
    }
    socialAndEmotionalRubric {
      id
      documentType
      document {
        ...documentFragment
      }
    }
  }
  ${DocumentFragment}
`;

export const ADD_ASSESSMENT_UNIT_RUBRIC = gql`
  mutation AddAssessmentUnitRubric($input: AddAssessmentContentDocumentInput!) {
    addAssessmentRubric(input: $input) {
      id
      ...AssessmentRubricsFragment
    }
  }
  ${assessmentRubricsFragment}
`;

export const DELETE_ASSESSMENT_UNIT_RUBRIC = gql`
  mutation DeleteAssessmentUnitRubric(
    $input: DeleteAssessmentContentDocumentInput!
  ) {
    deleteAssessmentRubric(input: $input) {
      id
      ...AssessmentRubricsFragment
    }
  }
  ${assessmentRubricsFragment}
`;
